<template>
  <nav>
    <!-- <v-toolbar flat app extended extension-height="1"> -->
    <v-app-bar>
      <v-app-bar-nav-icon
        v-if="$store.state.isUserLoggedIn"
        class="grey--text"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="title grey--text">
        秋邀-超级控制台
      </v-toolbar-title>
      <div v-if="$store.state.isUserLoggedIn">
        <v-tooltip
          bottom
          v-for="(status, indexStatus) in platformSpecialStatus"
          v-bind:key="`status-${indexStatus}`"
        >
          <template v-slot:activator="{ on }">
            <v-icon color="grey" dark v-on="on" class="px-1">local_cafe</v-icon>
          </template>
          <span>{{ status.status }}状态 | {{ status.description }}</span>
        </v-tooltip>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          text
          v-if="!$store.state.isUserLoggedIn"
          @click="navigateTo({ name: 'login-mobile' })"
        >
          登录
        </v-btn>
        <v-menu v-if="$store.state.isUserLoggedIn" offsetY>
          <template v-slot:activator="{ on }">
            <v-btn text color="grey" v-on="on">
              <v-icon left> expand_more </v-icon>
              <span>{{ $store.state.account.tutor.nickname }}</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="logout">
              <v-list-item-title>
                <v-icon left>power_settings_new</v-icon>
                退出
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-progress-linear
        :active="$store.state.queryingState"
        :indeterminate="$store.state.queryingState"
        absolute
        bottom
      ></v-progress-linear>
    </v-app-bar>
    <v-navigation-drawer
      v-if="$store.state.isUserLoggedIn"
      v-model="drawer"
      app
      fixed
    >
      <v-list>
        <v-list-group
          v-for="link in links"
          :key="link.title"
          v-model="link.active"
          :prepend-icon="link.action"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="link.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subLink in link.subLinks"
            :key="subLink.title"
            router
            :to="subLink.route"
          >
            <v-list-item-content>
              <v-list-item-title v-text="subLink.title"></v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon>{{ subLink.action }}</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
// import i18n from '@/plugins/i18n'
import PlatformService from '@/services/PlatformService'
import consola from 'consola'

export default {
  async mounted () {
    // 检查平台特殊状态
    const resPlatformSpecialStatus =
      await PlatformService.getPlatformSpecialStatus({ dateTime: new Date() })
    this.platformSpecialStatus = resPlatformSpecialStatus.data
    consola.info(`平台特殊状态检查：${this.platformSpecialStatus}`)
  },
  data () {
    return {
      drawer: true,
      alert: true,
      platformSpecialStatus: [],
      links: [
        {
          action: 'dashboard',
          title: '总体指标',
          subLinks: [
            { title: '概览', route: '/' } // 总体结课情况，利润，活跃私教，等等
          ]
        },
        {
          action: 'account_balance',
          title: '财务管理', // 一些财务相关内容，提现退款审核
          subLinks: [
            // { title: '机构提现审核', route: '/finance/organization-withdraw' }, // 机构提现申请查看与审核
            { title: '提现审核', route: '/finance/user-withdraw' }, // 机构提现申请查看与审核
            { title: '/学员退款审核', route: '/manage/students' } // 学员退款提现申请查看与审核
          ]
        },
        {
          action: 'school',
          title: '机构管理', // 以机构为单位快速定位项目，班级，学员与私教
          subLinks: [
            { title: '/机构列表', route: '/lesson/templates' }, // 列出所有机构, 并逐渐连接至教师，项目，学员等，进行较好的定位。
            { title: '项目列表', route: '/organization-management/programs' } // 列出所有项目
          ]
        },
        {
          action: 'supervised_user_circle',
          title: '私教管理', // 直接列出所有私教，并连接至私教相关操作
          subLinks: [{ title: '/私教列表', route: '/my/membership' }]
        },
        {
          action: 'event',
          title: '教学管理', // 平台相关操作
          subLinks: [{ title: '课程列表', route: '/lesson/lesson-templates' }]
        },
        {
          action: 'meeting_room',
          title: '班级管理', // 直接列出所有学员，并连接至学员相关操作
          subLinks: [{ title: '班级列表', route: '/classes' }]
        },
        {
          action: 'face',
          title: '学员管理', // 直接列出所有学员，并连接至学员相关操作
          subLinks: [{ title: '/学员列表', route: '/income/organization' }]
        },
        {
          action: 'fingerprint',
          title: '用户管理', // 所有用户相关操作
          subLinks: [{ title: '/重置密码', route: '/my/membership' }]
        },
        {
          action: 'settings',
          title: '平台管理', // 平台相关操作
          subLinks: [{ title: '/平台管理', route: '/my/membership' }]
        }
      ]
    }
  },
  methods: {
    navigateTo (route) {
      this.$router.push(route) // the $router is attached by default
    },
    logout () {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setAccount', null)
      this.$store.dispatch('setVersion', null)
      this.$store.dispatch('setQueryingState', null)
      // TODO: redirect to login page ..
      this.$router.push({
        name: 'login'
      })
    }
  }
}
</script>
